module.exports = __webpack_public_path__ + "img/3-7-credit-one.4ac1569d.jpg";